export default __webpack_public_path__ + "static/media/myob.5608de4b.png";